import type { ReactElement, ReactNode } from "react";
import { Route } from "react-router-dom";

type CreateResourceRoutesOptions = {
  /** Register /:id/clone */
  withClone?: boolean;
  /** Extra nested routes (e.g. listini) — placed before :id */
  extra?: ReactNode;
};

/**
 * Returns Route elements for list + new + optional clone + :id.
 * Must be used as a child expression inside <Routes>, not as <ResourceRoutes />:
 *
 *   {createResourceRoutes("/clienti", <Clienti />, { withClone: true })}
 *
 * React Router only accepts <Route> or Fragment as direct <Routes> children.
 */
export function createResourceRoutes(
  path: string,
  element: ReactElement,
  options: CreateResourceRoutesOptions = {},
): ReactNode {
  const { withClone = false, extra } = options;
  return (
    <>
      <Route path={path} element={element} />
      <Route path={`${path}/new`} element={element} />
      {withClone ? (
        <Route path={`${path}/:id/clone`} element={element} />
      ) : null}
      {extra}
      <Route path={`${path}/:id`} element={element} />
    </>
  );
}
